<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-card class="floating d-flex flex-column" v-if="visible && segment">
    <v-card-title class="py-6">
      <div class="text-h5">motionplan editor</div>
      <v-spacer></v-spacer>
      <v-btn icon color="blue darken-1" @click="hideMotionplanEditor" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="py-0">

      <v-container fluid class="py-0">
        <v-row dense>
          <v-col>
            Motionplan: {{ this.motionplan.name ? this.motionplan.name : this.motionplan.id }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="5" class="d-flex justify-start">
            IdSegment: {{ segment.IdentifierSegment }}
            <br />
            IdPoint: {{ segment.IdentifierPoint }}
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn icon elevation="2" color="black" @click="openFirstSegmentEditor" :disabled="!(segmentIndex > 0)">
              <v-icon>mdi-chevron-triple-left</v-icon> </v-btn>
            <v-btn icon elevation="2" color="black" @click="openPreviousSegmentEditor" :disabled="!(segmentIndex > 0)">
              <v-icon>mdi-chevron-left</v-icon> </v-btn>
            <v-btn icon elevation="2" color="black" @click="openNextSegmentEditor"
              :disabled="!(this.segmentIndex < (this.motionplan.data.length - 1))">
              <v-icon>mdi-chevron-right</v-icon></v-btn>
            <v-btn icon elevation="2" color="black" @click="openLastSegmentEditor"
              :disabled="!(this.segmentIndex < (this.motionplan.data.length - 1))">
              <v-icon>mdi-chevron-triple-right</v-icon></v-btn>

          </v-col>
        </v-row>
      </v-container>
    </v-card-subtitle>

    <v-card-text style="overflow-y: scroll; flex-grow: 1;">
      <v-container fluid class="py-0" v-if="$auth.subscription && $auth.subscription !== '__SUB_CIVIL_VECTOR'">
        <v-row v-if="showFunctionEditor" dense>
          <v-col cols="6">
            <v-radio-group v-if="segmentIndex === 0" v-model="selectedFunctionGroup" dense hide-details>
              <v-radio v-for="functionGroup in rbpFunctionGroupsPoint" :key="functionGroup.name"
                :label="functionGroup.name" :value="functionGroup.functions"></v-radio>
            </v-radio-group>

            <v-radio-group v-else v-model="selectedFunctionGroup" dense hide-details>
              <v-radio v-for="functionGroup in rbpFunctionGroupsLine" :key="functionGroup.name"
                :label="functionGroup.name" :value="functionGroup.functions"></v-radio>
            </v-radio-group>


          </v-col>
          <v-col cols="6">

          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn :disabled="connectState || segmentIndex == 0" :loading="loading" text @click="disconnect()"
              style="text-align: left;">
              REMOVE SEGMENT </br>
            </v-btn>
            <v-btn :loading="loading"
              :disabled="map.motionplans.length < 2 || !(segmentIndex == 0 || this.segmentIndex == (this.motionplan.data.length - 1))"
              text @click="setConnectState()">

              {{ connectState ? "STOP CONNECTING" : "CONNECT SEGMENT" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else fluid>
        <v-row dense>
          <v-col>
            <v-radio-group v-model="selectedFunctionGroup" dense hide-details>
              <v-row>
                <v-col cols="6">
                  <v-label>GNSS</v-label>
                  <v-radio v-for="functionGroup in vectorFunctionGroupsGNSS" :key="functionGroup.name"
                    :label="functionGroup.name" :value="functionGroup.functions"></v-radio>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="9">
                      <v-subheader dense> {{
                        getArgName(157,
                          0) }}: </v-subheader>
                    </v-col><v-col cols="3">
                      <v-text-field dense
                        :value="getIdentifierFunctionFromVectorGroup('gnss', 'Rijden op GNSS (bogen< 5m)', 157).Arguments[0]"
                        @change="updateArgGroups(getIdentifierFunctionFromVectorGroup('gnss', 'Rijden op GNSS (bogen< 5m)', 157).IdentifierFunction, 0, $event)"></v-text-field></v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-label>Lidar</v-label>
                  <v-radio v-for="functionGroup in vectorFunctionGroupsLidar" :key="functionGroup.name"
                    :label="functionGroup.name" :value="functionGroup.functions"></v-radio>
                </v-col><v-col cols="6"><v-row>
                    <v-col cols="9">
                      <v-subheader dense>{{
                        getArgName(153,
                          0) }}: </v-subheader>
                    </v-col><v-col cols="3">
                      <v-text-field dense
                        :value="getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).Arguments[0]"
                        @change="updateArgGroups(getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).IdentifierFunction, 0, $event)"></v-text-field></v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9">
                      <v-subheader dense>{{
                        getArgName(153,
                          1) }}: </v-subheader>
                    </v-col><v-col cols="3">
                      <v-text-field dense
                        :value="getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).Arguments[1]"
                        @change="updateArgGroups(getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).IdentifierFunction, 1, $event)"></v-text-field></v-col>
                  </v-row><v-row>
                    <v-col cols="9">
                      <v-subheader dense>{{
                        getArgName(153,
                          2) }}: </v-subheader>
                    </v-col><v-col cols="3">
                      <v-text-field dense
                        :value="getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).Arguments[2]"
                        @change="updateArgGroups(getIdentifierFunctionFromVectorGroup('lidar', 'Start Lidar navigatie', 153).IdentifierFunction, 2, $event)"></v-text-field></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col cols="6">

          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <v-select v-model="selectedFunctions" :items="allFunctions" item-value="functionObject.IdentifierFunction"
              item-text="functionObject.IdentifierFunction" :menu-props="{ height: '200' }" label="Select" multiple>
              <template slot="item" slot-scope="data">
                {{ data.item.name }} - id: {{ data.item.functionObject.IdentifierFunction }} - args: {{
                  data.item.functionObject.NrOfArgsFunction }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="6">

          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <v-container fluid>
              <v-row dense v-for="functionObject in segment.functionArray" :key="functionObject.IdentifierFunction">
                <v-col>
                  {{ functionObject.IdentifierFunction }} - {{ getFunctionName(functionObject.IdentifierFunction) }}
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="6">
            <v-container fluid>
              <v-row dense v-for="functionObject in segment.functionArray" :key="functionObject.IdentifierFunction"
                v-if="functionObject.NrOfArgsFunction != 0">
                <v-col>
                  <v-container fluid>
                    <v-row dense v-for="(argument, index) in functionObject.Arguments" :key="index">
                      <v-col cols="9">
                        <v-subheader dense>{{ functionObject.IdentifierFunction }} - {{
                          getArgName(functionObject.IdentifierFunction,
                            index) }}: </v-subheader>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field :value="argument" dense
                          @change="updateArg(functionObject.IdentifierFunction, index, $event)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :loading="loading" :disabled="connectState || map.editActions.length == 0" text v-bind="attrs"
            v-on="on" @click="save()">
            Save
          </v-btn>
        </template>
        <span>Save</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :loading="loading" :disabled="connectState || map.editActions.length == 0" text v-bind="attrs"
            v-on="on" @click="undo()">
            Undo
          </v-btn>
        </template>
        <span>Undo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn :loading="loading" text v-bind="attrs" v-on="on" @click="cancel">
            cancel
          </v-btn>
        </template>
        <span>cancel</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as CONST from "../../Constants"

export default {
  components: {},
  data: () => ({
    loading: false,
    visible: false,
    motionplan: null,
    originalMPString: "",
    segment: null,
    segmentIndex: -1,
    connectState: false, // TODO SET STATE AT EVERY FUNCTIONCALL
    showFunctionEditor: false,
    vectorFunctions: [
      {
        name: "Stop to wait for good quality setpoint from lidar",
        argumentNames: [],
        functionObject: { IdentifierFunction: 101, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Navigate using GNSS",
        argumentNames: [],
        functionObject: { IdentifierFunction: 151, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Navigate using lidar looking both forward and backward",
        argumentNames: ["Distance to poles on right-hand side [m]", "Inter pole distance (afstand tussen de palen) [m]", "Intra pole distance (hartafstand) [m]"],
        functionObject: { IdentifierFunction: 152, NrOfArgsFunction: 3, Arguments: [] },
      },
      {
        name: "Navigate using lidar looking forward only",
        argumentNames: ["Distance to poles on right-hand side [m]", "Inter pole distance (afstand tussen de palen) [m]", "Intra pole distance (hartafstand) [m]"],
        functionObject: { IdentifierFunction: 153, NrOfArgsFunction: 3, Arguments: [] },
      },
      {
        name: "Navigate using lidar looking backward only",
        argumentNames: ["Distance to poles on right-hand side [m]", "Inter pole distance (afstand tussen de palen) [m]", "Intra pole distance (hartafstand) [m]"],
        functionObject: { IdentifierFunction: 154, NrOfArgsFunction: 3, Arguments: [] },
      },
      {
        name: "Search for end of roof by radar and wait for good quality GNSS",
        argumentNames: [],
        functionObject: { IdentifierFunction: 155, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Set speed on this segment to the user-defined setpoint",
        argumentNames: [],
        functionObject: { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Set speed on this segment [speed_d]",
        argumentNames: ["Speed [m/s]"],
        functionObject: { IdentifierFunction: 157, NrOfArgsFunction: 1, Arguments: [] },
      },
      {
        name: "Drive under prerequisite that hitch has reached setpoint, otherwise stop.",
        argumentNames: ["Setpoint [hitch actuator counts from lowest position]"],
        functionObject: { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [] },
      },
      {
        name: "Change to homing route when battery low",
        argumentNames: ["Battery limit"],
        functionObject: { IdentifierFunction: 159, NrOfArgsFunction: 1, Arguments: [] },
      },
      {
        name: "Stop and lift hitch during 5 seconds",
        argumentNames: [],
        functionObject: { IdentifierFunction: 102, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Stop and lower hitch during 5 seconds",
        argumentNames: [],
        functionObject: { IdentifierFunction: 103, NrOfArgsFunction: 0, Arguments: [] },
      },
    ],
    rbpFunctions: [
      {
        name: "Spray point for a duration",
        argumentNames: [],
        functionObject: { IdentifierFunction: 1, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Drill while waiting for event",
        argumentNames: [],
        functionObject: { IdentifierFunction: 2, NrOfArgsFunction: 0, Arguments: [] },
      },
      {
        name: "Spray segment",
        argumentNames: ["Spray on/off"],
        functionObject: { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [] },
      },
    ],
    activeFunctions: [],
    allFunctions: [],
    allVectorGroupFunctions: [],
    rbpFunctionGroupsLine: [
      {
        name: "Spray Line",
        functions: [
          { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [1] },
        ]
      },
      {
        name: "Spray Line + Spray End Point",
        functions: [
          { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [1] },
          { IdentifierFunction: 1, NrOfArgsFunction: 0, Arguments: [] },
        ]
      },
      {
        name: "Drive Line",
        functions: [
          { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [0] },
        ]
      },
      {
        name: "Drive Line + Spray End Point",
        functions: [
          { IdentifierFunction: 1, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [0] },
        ]
      },
      {
        name: "Drive Line + Drill Point",
        functions: [
          { IdentifierFunction: 2, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [0] },
        ]
      },
    ],
    rbpFunctionGroupsPoint: [
      {
        name: "Spray Point",
        functions: [
          { IdentifierFunction: 1, NrOfArgsFunction: 0, Arguments: [] },
        ]
      },
      {
        name: "Drill Point",
        functions: [
          { IdentifierFunction: 2, NrOfArgsFunction: 0, Arguments: [] },
        ]
      },
      {
        name: "Don't Spray Point",
        functions: []
      }
    ],
    vectorFunctionGroupsGNSS: [
      {
        name: "Rijden op GNSS",
        functions: [
          { IdentifierFunction: 151, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [0] }
        ]
      },
      {
        name: "Rijden op GNSS (bogen< 5m)",
        functions: [
          { IdentifierFunction: 151, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 157, NrOfArgsFunction: 1, Arguments: [0.28] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [1] }
        ]
      },
      {
        name: "Rijden op GNSS (bogen < 5m) + start panelen",
        functions: [
          { IdentifierFunction: 151, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 157, NrOfArgsFunction: 1, Arguments: [0.28] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [1] },
          { IdentifierFunction: 101, NrOfArgsFunction: 0, Arguments: [] }
        ]
      },
      {
        name: "Rijden op GNSS + start panelen",
        functions: [
          { IdentifierFunction: 151, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [0] },
          { IdentifierFunction: 101, NrOfArgsFunction: 0, Arguments: [] }
        ]
      }
    ],
    vectorFunctionGroupsLidar: [
      {
        name: "Start Lidar navigatie",
        functions: [
          { IdentifierFunction: 153, NrOfArgsFunction: 3, Arguments: [0.84, 1.95, 1.00] },
          { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [0] }
        ]
      },
      {
        name: "Lidar Navigatie",
        functions: [
          { IdentifierFunction: 152, NrOfArgsFunction: 3, Arguments: [0.84, 1.95, 1.00] },
          { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [0] }
        ]
      },
      {
        name: "Einde Lidar Navigatie",
        functions: [
          { IdentifierFunction: 154, NrOfArgsFunction: 3, Arguments: [0.84, 1.95, 1.00] },
          { IdentifierFunction: 155, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 156, NrOfArgsFunction: 0, Arguments: [] },
          { IdentifierFunction: 158, NrOfArgsFunction: 1, Arguments: [0] }
        ]
      }
    ],

    selectedFunctionGroup: null,
  }),
  props: {
    /* Map.vue reference */
    map: {
      required: true,
    },
  },
  computed: {
    selectedFunctions: {
      get() {
        var arr = []
        this.segment.functionArray.forEach(functionObject => {
          arr.push(functionObject.IdentifierFunction);
        });
        return arr
      },
      set(newValue) {
        var added = newValue.filter((x) => !this.segment.functionArray.find((f) => f.IdentifierFunction == x));
        added.forEach(e => {
          var functionToAdd = this.allFunctions.find(f => f.functionObject.IdentifierFunction == e).functionObject;
          // if (this.checkForValidMotionplan(functionToAdd.IdentifierFunction, "Add")) {
          //   this.segment.addFunction(functionToAdd);
          // }
          this.segment.addFunction(functionToAdd);
        });

        var removed = this.segment.functionArray.filter((f) => !newValue.find((x) => x == f.IdentifierFunction));
        removed.forEach(e => {
          this.segment.removeFunction(e.IdentifierFunction);
        });

        this.map.updateMotionplan(this.motionplan.id, this.segmentIndex)
      }
    }
  },
  watch: {
    selectedFunctionGroup(value, oldVal) {
      if (oldVal && value) {
        console.log("SAVE ACTION AS A FUNCTION CHANGE: ")
        var functionArray = Array.from(value)
        this.segment.setFunctions(functionArray);

        this.onSegmentChange(structuredClone(oldVal), structuredClone(value))
        this.map.updateMotionplan(this.motionplan.id, this.segmentIndex);
      }
    },
    segment(value, oldVal) {
      if (this.$auth.subscription == '__SUB_CIVIL_VECTOR') {
        // check if segment has function group?
        var functionGroup = null;
        this.allVectorGroupFunctions.forEach(vFunctionGroup => {
          var counter = 0;
          for (let i = 0; i < vFunctionGroup.functions.length; i++) {
            if (value.functionArray[i] && value.functionArray[i].IdentifierFunction == vFunctionGroup.functions[i].IdentifierFunction) {
              counter++;
            }
          }
          if (counter == value.functionArray.length) {
            functionGroup = vFunctionGroup;
            return;
          }
        });

        // if functiongroup is inside segment

        for (let i = 0; i < functionGroup.functions.length; i++) {
          for (let j = 0; j < functionGroup.functions[i].Arguments.length; j++) {
            if (functionGroup.functions[i].Arguments[j] != value.functionArray[i].Arguments[j]) {
              functionGroup.functions[i].Arguments[j] = value.functionArray[i].Arguments[j]
            }
          }
        }
      }
    }
  },
  methods: {
    test() {
      console.log("test")
    },
    setConnectState() {
      //CHECK FOR MULTIPLE MOTIONPLANS
      if (!this.connectState) {
        if (this.segmentIndex == 0) {
          // reverse input mp
          this.map.setConnectState(this.motionplan, true, this.segment.X, this.segment.Y)
        } else {
          this.map.setConnectState(this.motionplan, false, this.segment.X, this.segment.Y)
        }
      } else {
        this.map.undoConnectState()
        this.map.openSegmentEditor(this.motionplan.id, this.segmentIndex);
      }

      this.connectState = !this.connectState
    },
    onSegmentChange(oldFunctiongroup, newFunctiongroup) {
      this.map.editActions.push({
        action: "segmentchange",
        mpId: this.motionplan.id,
        mpName: this.motionplan.name,
        segmentIndex: this.segmentIndex,
        oldFunctiongroup: oldFunctiongroup,
        newFunctiongroup: newFunctiongroup
      })

      const i = this.map.motionplans.findIndex(mp => mp.id == this.motionplan.id)
      this.map.motionplans[i] = { id: this.motionplan.id, name: this.motionplan.name, mp: this.motionplan.getMotionplanString() }
    },
    // GENERATE UNIQUE ID INSTEAD OF RANDOM ID
    generateId() {
      return Math.floor(Math.random() * 100000)
    },
    save() {
      this.loading = true;
      console.log("SAVE ALL ACTIONS")
      const mpsInTask = [] // only ids
      const mpsInArray = this.map.motionplans
      const taskId = this.map.task.taskId
      const requests = []


      this.map.task.getResourceSet(CONST.__RESOURCETYPE_MOTIONPLAN).forEach(resource => {
        if (resource.identifierType == CONST.__IDENTIFIERTYPE_MOTIONPLAN) {
          mpsInTask.push(resource.dxffile[0].dxffileId)
        }
      })

      console.log(mpsInTask)
      console.log(mpsInArray)
      // for each mp in array, and each mp in task:

      // delete motionplans that are in task but not in motionplan array
      // this.$axios.post(route("api.tasks.deletemotionplan", [TASKID, MOTIONPLANID]))
      const mpsToDelete = mpsInTask.filter(mpId => !mpsInArray.some(mpObj => mpObj.id == mpId)) // only mpIds [1,2,3]
      mpsToDelete.forEach(mpId => {
        console.log("DELETE: " + mpId)
        requests.push(this.$axios.post(route("api.tasks.deletemotionplan", [taskId, mpId])))
      });

      // add motionplans which are not in task but are in motionplan array
      // this.$axios.post(route("api.tasks.addmotionplan", TASKID), {file: new File([new Blob([MOTIONPLANSTR], "mp.log")}, { headers: { "Content-Type": "multipart/form-data" }, })
      //const mpsToAdd = [] // only mp strings ["mp1", "mp2"]
      const mpsToAdd = mpsInArray.filter(mpObj => !mpsInTask.some(mpId => mpId == mpObj.id))
      mpsToAdd.forEach(mpObj => {
        let data = new FormData();
        console.log("ADD: ")
        console.log(mpObj.mp)
        data.set("file", new File([new Blob([mpObj.mp])], "mp.log"));
        data.set("name", mpObj.name);
        requests.push(this.$axios.post(route("api.tasks.addmotionplan", taskId), data, { headers: { "Content-Type": "multipart/form-data" }, }))
      })

      // edit motionplans that are in motionplan array and in task (?) 
      // this.$axios.post(route("api.tasks.editmotionplan", [TASKID, MOTIONPLANID]), {file: new File([new Blob([MOTIONPLANSTR], "mp.log")}, { headers: { "Content-Type": "multipart/form-data" }, })
      // const mpsToEdit = [] // mp ids and strings [{id:1, mp:"mp1"}, {id:2, mp:"mp2"}]
      const mpsToEdit = mpsInArray.filter(mpObj => mpsInTask.some(mpId => mpId == mpObj.id)).filter(mpObj => {
        const segmentChanges = this.map.editActions.filter(editAction => editAction.action == "segmentchange")
        return segmentChanges.some(editAction => editAction.mpId == mpObj.id)
      })

      mpsToEdit.forEach(mpObj => {
        let data = new FormData();
        console.log("EDIT: " + mpObj.id)
        console.log(mpObj.mp)
        data.set("file", new File([new Blob([mpObj.mp])], "mp.log"));
        requests.push(this.$axios.post(route("api.tasks.editmotionplan", [taskId, mpObj.id]), data, { headers: { "Content-Type": "multipart/form-data" }, }))
      })


      Promise.all(requests)
        .then(data => {
          // Process the data from all responses
          console.log(data);
          this.loading = false;
          this.$emit("closeTask");
          this.$emit("openTask", taskId);
        })
        .catch(error => {
          // Handle any errors
          console.error('One or more requests failed:', error);
        });

    },
    cancel() {
      const length = this.map.editActions.length // if used directly length gets reduced in revert action function

      if (this.connectState) {
        this.setConnectState()
      }

      for (let i = 0; i < length; i++) {
        console.log(this.map.editActions[0].action)
        this.revertAction()
      }
      this.hideMotionplanEditor()
    },
    undo() {
      const lastAction = this.map.editActions.at(-1);

      let mpId;
      let segmentIndex = 0

      if (lastAction.action == "segmentchange") {
        mpId = lastAction.mpId
        segmentIndex = lastAction.segmentIndex
      } else {
        mpId = lastAction.prevMps[0].id
      }

      this.revertAction() //
      this.map.openSegmentEditor(mpId, segmentIndex)
    },
    revertAction() {
      const action = this.map.editActions.at(-1)

      console.log(action)
      if (action.action == "segmentchange") {
        const mpObj = this.map.motionplans.find(mpObj => mpObj.id == action.mpId)
        const mp = this.map.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").findMotionplanElement(action.mpId).motionplan

        mp.data[action.segmentIndex].setFunctions(action.oldFunctiongroup);
        mpObj.mp = mp.getMotionplanString()

      } else {
        action.newMps.forEach(mpToRemove => {
          this.map.motionplans.splice(this.map.motionplans.findIndex(mp => mp.id == mpToRemove), 1);
        })

        action.prevMps.forEach(mpToAdd => {
          this.map.motionplans.push(mpToAdd)
        })
      }

      this.map.editActions.pop();
      this.map.openMotionplanCollection()
    },
    disconnect() {
      const [mp1, mp2] = this.motionplan.disconnectAt(this.segmentIndex)
      const mp1Id = this.generateId()
      const mp2Id = this.generateId()

      this.map.editActions.push({
        action: "disconnect", newMps: [mp1Id, mp2Id], prevMps: [{
          id: this.motionplan.id,
          name: this.motionplan.name,
          mp: this.motionplan.getMotionplanString()
        }]
      })

      this.map.motionplans.splice(this.map.motionplans.findIndex(mp => mp.id == this.motionplan.id), 1);

      this.map.motionplans.push(...[{ id: mp1Id, name: mp1.name, mp: mp1.getMotionplanString() }, { id: mp2Id, name: mp2.name, mp: mp2.getMotionplanString() }])


      // remember hidden motionplans somehow
      this.map.openMotionplanCollection()
      this.map.openSegmentEditor(mp2Id, 0)

      // this.hideMotionplanEditor() // select segment that was removed 
    },
    async connect(mp1, mp2, reverseMp1, reverseMp2) {
      this.loading = true
      const newMp = await this.getNewMpFromFileservice(mp1, mp2, reverseMp1, reverseMp2)
      this.loading = false
      const newMpId = this.generateId()

      console.log(newMp)
      console.log(newMpId)

      this.map.editActions.push({
        action: "connect", newMps: [newMpId], prevMps: [{
          id: mp1.id,
          name: mp1.name,
          mp: mp1.getMotionplanString()
        }, {
          id: mp2.id,
          name: mp2.name,
          mp: mp2.getMotionplanString()
        },
        ]
      })

      this.map.motionplans.splice(this.map.motionplans.findIndex(mp => mp.id == mp1.id), 1);
      this.map.motionplans.splice(this.map.motionplans.findIndex(mp => mp.id == mp2.id), 1);

      this.map.motionplans.push({ id: newMpId, name: mp1.name, mp: newMp })

      this.connectState = false
      this.map.undoConnectState()
      // this.map.openMotionplanCollection()
      this.map.openSegmentEditor(newMpId, mp1.data.length)
    },
    async getNewMpFromFileservice(mp1, mp2, reverseMp1, reverseMp2) {
      let data = new FormData();
      data.set("mp1", new File([new Blob([mp1.getMotionplanString()])], "mp1.log"));
      data.set("mp2", new File([new Blob([mp2.getMotionplanString()])], "mp2.log"));
      data.set("mp1Reversed", reverseMp1 ? 1 : 0)
      data.set("mp2Reversed", reverseMp2 ? 1 : 0)
      const res = await this.$axios.post(route("api.motionplan.combine"), data, { headers: { "Content-Type": "multipart/form-data" }, })

      return res.data
    },
    uploadMotionplan() {
      this.loading = true;

      let data = new FormData();
      data.set("file", new File([new Blob([this.motionplan.getMotionplanString()])], "motionplan.log"));

      this.$axios.post(route("api.tasks.editmotionplan", [this.map.task.taskId, this.motionplan.id]), data, { headers: { "Content-Type": "multipart/form-data" }, }).then((res) => {
        this.$emit("closeTask");
        this.$emit("openTask", res.data);
      }).catch((error) => {
        console.log(error);
      });
    },
    openNextSegmentEditor() {
      if (this.segmentIndex < (this.motionplan.data.length - 1)) {
        this.map.openSegmentEditor(this.motionplan.id, this.segmentIndex + 1);
      }
    },
    openPreviousSegmentEditor() {
      if (this.segmentIndex > 0) {
        this.map.openSegmentEditor(this.motionplan.id, this.segmentIndex - 1);
      }
    },
    openLastSegmentEditor() {
      if (this.segmentIndex < (this.motionplan.data.length - 1)) {
        this.map.openSegmentEditor(this.motionplan.id, this.motionplan.data.length - 1);
      }
    },
    openFirstSegmentEditor() {
      if (this.segmentIndex > 0) {
        this.map.openSegmentEditor(this.motionplan.id, 0);
      }
    },
    setSegment(motionplan, segmentIndex) {
      this.selectedFunctionGroup = null
      this.motionplan = motionplan;
      this.segmentIndex = segmentIndex
      this.segment = motionplan.data[segmentIndex];
      this.visible = true;
      this.showFunctionEditor = this.map.task.operationPractice == CONST.__OP_MOTIONPLAN;

      this.activeFunctions = this.$auth.subscription == "__SUB_CIVIL_ROADPLOTTER" ? this.rbpFunctions : this.vectorFunctions;
      this.allFunctions = this.rbpFunctions.concat(this.vectorFunctions);
      this.allVectorGroupFunctions = this.vectorFunctionGroupsGNSS.concat(this.vectorFunctionGroupsLidar);

      document.addEventListener('keydown', this.selectFromKeyboard);


      this.$nextTick(() => {
        this.selectedFunctionGroup = this.findCurrentFunctionGroup().functions;
      })

    },
    findCurrentFunctionGroup() {
      var functionGroupsCopy = null;

      if (this.segmentIndex == 0) {
        functionGroupsCopy = Array.from(this.rbpFunctionGroupsPoint);
      } else {
        functionGroupsCopy = Array.from(this.rbpFunctionGroupsLine);
      }

      functionGroupsCopy = functionGroupsCopy.filter(functiongroup => functiongroup.functions.length == this.segment.functionArray.length)

      this.segment.functionArray.forEach(mpfunction => {
        functionGroupsCopy = functionGroupsCopy.filter(functiongroup => {
          return functiongroup.functions.some(fnc => {
            if (fnc.IdentifierFunction == mpfunction.IdentifierFunction) {
              if (mpfunction.NrOfArgsFunction > 0) {
                for (let i = 0; i < mpfunction.NrOfArgsFunction; i++) {
                  if (mpfunction.Arguments[i] != fnc.Arguments[i]) {
                    return false;
                  }
                }
                return true;
              } else {
                return true;
              }
            }
            return false;
          })
        })
      })

      return functionGroupsCopy[0] ? functionGroupsCopy[0] : null;
    },
    selectFromKeyboard(event) {
      if (this.connectState) return;
      switch (event.key) {
        case "ArrowLeft":
          if (event.ctrlKey) {
            // Ctrl + Left Arrow pressed
            this.openFirstSegmentEditor();
          } else {
            this.openPreviousSegmentEditor();
          }
          break;
        case "ArrowRight":
          if (event.ctrlKey) {
            // Ctrl + Left Arrow pressed
            this.openLastSegmentEditor();
          } else {
            this.openNextSegmentEditor()
          }
          break;
      }
    },
    getFunctionName(functionId) {
      var func = this.allFunctions.find(f => {
        return f.functionObject.IdentifierFunction == functionId
      })
      return func.name
    },
    getArgName(functionId, argIndex) {
      var func = this.allFunctions.find(f => {
        return f.functionObject.IdentifierFunction == functionId
      })

      return func.argumentNames[argIndex];
    },
    getIdentifierFunctionFromVectorGroup(group, groupname, functionId) {
      var identifier = null;
      if (group == "lidar") {
        this.vectorFunctionGroupsLidar.forEach(element => {
          var count = 0;
          element.functions.forEach(element2 => {
            this.segment.functionArray.forEach(segmentfunction => {
              if (segmentfunction.IdentifierFunction == element2.IdentifierFunction) {
                count++;
              }
            });
          });
          if (count == element.functions.length) {
            identifier = element.functions[0];
            return;
          }
        });
      } else if (group == "gnss") {
        this.vectorFunctionGroupsGNSS.forEach(element => {
          var count = 0;
          element.functions.forEach(element2 => {
            this.segment.functionArray.forEach(segmentfunction => {
              if (segmentfunction.IdentifierFunction == element2.IdentifierFunction) {
                count++;
              }
            });
          });
          if (count == element.functions.length) {
            identifier = element.functions[0];
            return;
          }
        });
      }

      if (identifier && (identifier.Arguments.length > 0)) {
        return identifier;
      } else {
        var group = this.allVectorGroupFunctions.find(f => {
          return f.name == groupname
        });
        var vectorFunction = group.functions.find(f => {
          return f.IdentifierFunction == functionId;
        });
        return vectorFunction;
      }
    },
    updateArg(IdentifierFunction, argIndex, value) {
      console.log("update arg for:" + IdentifierFunction)
      this.segment.changeArgForFunction(IdentifierFunction, argIndex, value);
    },
    updateArgGroups(IdentifierFunction, argIndex, value) {
      this.segment.changeArgForFunction(IdentifierFunction, argIndex, value);
    },
    hideMotionplanEditor() {
      if (this.connectState) {
        this.setConnectState()
      }

      document.removeEventListener('keydown', this.selectFromKeyboard);

      this.map.motionplanEditorClosed();
      this.visible = false;
    },
    motionplanToDxf() {
      let data = new FormData();
      data.set("dxffile", new File([new Blob([this.map.mapTaskInfo.getChildElement("MOTIONPLAN").motionplan.getMotionplanString()])], "motionplan.log"));

      this.$axios
        .post(route("api.motionplan.dxf"), data, {
          headers: { "Content-Type": "multipart/form-data" }, responseType: "blob",
        })
        .then((response) => {
          // TODO: check status
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          // TODO: better filename
          fileLink.setAttribute("download", response.headers['content-disposition'].match(/(?<=filename=)[^;]+/g)[0]);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    uploadDXF() {
      this.$emit("openUploadDXF");
    },
    close() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  },
};
</script>

<style scoped>
.floating {
  z-index: 75;
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: calc(30vw - 10px - 10px);
  max-height: calc(50vh - 10px);
}
</style>
